export const RECYCLING_COLOR = '#297a48';

export const RECYCLING_CHIP_BG = '#e8f9d8';
export const RECYCLING_CHIP_BORDER = '#96d845';
export const RECYCLING_CHIP_TEXT = '#35600a';
export const RECYCLING_CHIP_ICON = '#5CA314';
